module.exports = __webpack_public_path__ + "static/img/mpdpImgTwo1.3fea314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpImgTwo1.png
// module id = dLLj
// module chunks = 2